import React from 'react';
import {
  Box,
  costFormater,
  Inscription,
} from '@common-fe/common-fe';

import { Copay } from '@/modules/ExpressSetup/ExpressSetup.types.ts';

interface Props {
  copays?: Copay[];
}

const CopaysSummaryContainer: React.FC<Props> = ({
  copays,
}) => {
  if (!copays?.length) return null;
  return (
    <Box
      direction="row"
      justify="center"
      data-testid="copays-summary-container"
    >
      <Box
        direction="row"
        width="100%"
        wrap
        // gap="xs"
      >
        {copays?.map((copay: Copay, index) => (
          <Box
            key={index}
            direction="row"
            align="center"
            pad={{ vertical: 's', horizontal: 'm' }}
            border={{ size: '1px', color: 'border2' }}
            background="canvas"
            round="80px"
            height="46px"
            width="fit-content"
            margin={{ bottom: 'xs', right: 'xs' }}
            data-testid="copay-item"
          >
            <Inscription
              color="textBody"
              margin={{ right: 'xxxs' }}
              weight="bold"
              size="16px"
              lineHeight="22px"
              hasEllipsisMode
            >
              {copay?.description}
            </Inscription>
            <Inscription
              color="textSecondary"
              lineHeight="20px"
            >
              ({costFormater(+copay?.amount, true)})
            </Inscription>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default CopaysSummaryContainer;
